import SelectComponent from "@via/components/select/select";
import { type SelectOption, isSelectOption } from "@via/utils/interfaces";
import { useSchedulerList } from "@via/pages/runs/schedulers/schedulers.api";
import { type RunScheduler } from "common";
import { useMemo } from "react";

interface SchedulerValueInputProps {
  value: string;
  onChange: (value: string) => void;
}

export default function SchedulerValueInput({
  value,
  onChange,
}: SchedulerValueInputProps) {
  const { data: schedulers, isLoading } = useSchedulerList();

  const schedulerOptions: SelectOption[] = useMemo(() => {
    if (!schedulers) return [];
    const list = Array.isArray(schedulers) ? schedulers : schedulers.data;
    return list.map((s: RunScheduler) => ({
      label: s.name,
      value: String(s.id),
    }));
  }, [schedulers]);

  return (
    <SelectComponent
      name="schedulerValueInput"
      options={schedulerOptions}
      value={
        value
          ? (schedulerOptions.find(opt => opt.value === value) ?? null)
          : null
      }
      onChange={selected => {
        if (isSelectOption(selected)) {
          onChange(selected.value as string);
        }
      }}
      placeholder={isLoading ? "Loading..." : "Select scheduler"}
      isSearchable={true}
      isLoading={isLoading}
    />
  );
}
